//^ {1,}"(.+)("):
//replace with $1:
export default  {
  appAlexa: [],
  id: "test",
  name: "",
  brandID: "BCBS",
  brandName: "BCBS",
  coBrandLogoURL: "",
  dateRange: "2022-2023",
  networkName: "...",
  termsURL: "www.rrd.com",
  benefitBrand: "GeoBlue",
  datesToRemember: {
    fall: "Fall Date",
    spring: "Spring Date",
    summer: "Summer Date",
    waiverDeadline: "Waver dealines",
    optionalDate: "4/4/44",
    optionalDateLabel: "",
    datesFootNote: ""
  },
  brokerUrl: "www.BrokerSiteUrl.org",
  brokerPhone: "123-456-6789",
  includeAsaCoverage: "Y",
  includeAsaPlan: "Y",
  includeAsaWhereForCare: "Y",
  includeAsaImportantContacts: "Y",
  asaCoverage: {
    chart: [
      {
        title: "Cost and Dates of Coverage",
        summary: "",
        table: {
          tr: [
            {
              th: [
                "header Chart1",
                "Column 1",
                "Column 2",
                "Column 3",
                "Column 4",
                "Column 5"
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            }
          ]
        },
        footNote: ""
      },
      {
        title: "",
        summary: "",
        table: {
          tr: [
            {
              th: [
                "header Chart1",
                "Column 1",
                "Column 2",
                "Column 3",
                "Column 4",
                "Column 5"
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            },
            {
              td: [
                "",
                "",
                "",
                "",
                "",
                ""
              ]
            }
          ]
        },
        footNotes: {
          footNote: [
            "Additional information to include Part1",
            "Refund or Cancellation Posicies Optional part 2, for schools with direct pag and not handled by the broker part3"
          ]
        }
      }
    ],
    footNotes: {
      footNote: [
        "xxxx xxx x xxxx xxx xxxxxxxxxxxxxxxx",
        "xxxx xxx xxxxxxxxxxxxxxxx"
      ]
    },
    eligible: {
      group: [
        {
          title: "Who is eligible?",
          information:""
        },
        {
          title: "Coverage is available for dependents, too",
          information:""
        }
      ]
    }
  },
  asaPlan: {
    chart: {
      title: "Plan Overview",
      summary: [],
      table: {
        tr: [
          {
            th: [
              "header Chart1",
              "Cost if you use an In-Network Provider",
              "Cost if you use an Non-Network Provider",
              "Column 3"
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          },
          {
            td: [
              "",
              "",
              "",
              ""
            ]
          }
        ]
      },
      footNotes: {
        footNote: [
          "foot note 1",
          "foot note 2"
        ]
      }
    },
    currentOEPlan: "formatted url",
    previousOEPlan: "formatted url",
    summaryOfBenefits: "formatted url",
    footNotes: {
      footNote: [
        "plan footnotes",
        "plan footnotes"
      ]
    }
  },
  asaWhereForCare: {
    convenientCare: {
      section: {
        name: "Convenient",
        summary: "",
        footNotes: {
          footNote: [
            "section footnotes",
            "section footnotes"
          ]
        },
        services: {
          service: [
            {
              name: "Sydney Health App",
              content: "With the SydneySM Health mobile app through Anthem Student Advantage, you have instant access to:\n<ul>\n<li>Your member ID card.</li>\n<li>Your school has opted for a digital ID card.</li>\n</ul>\n\nYour digital ID card is available on anthem.com or the Sydney Health mobile app when you register with your student ID number on or after your plan effective date. Print a copy of your card anytime or show it to your doctor from your smartphone. If you prefer to have a hard\ncopy of your ID Card, you can call our Customer Service Department at <b>555-123-1234</b> and request a hard copy of your ID card on or after your plan effective date.\n<ul>\n<li>The Find Care tool.\n<li>Information about your plan benefits.</li>\n<li>Health tips that are tailored to you.</li>\n<li>LiveHealth Online and 24/7 NurseLine.</li>\n<li>Student support specialists\n(through click-to-chat or by phone).</li>\n</ul>\nAccess the Sydney Health app\nGo to the App Store<sup>SM</sup> or Google Play<sup>TM</sup> and search for the Sydney Health app to download it today."
            },
           
          ]
        }
      }
    },
    studentHealthServices: {
 
    }
  },
  asaImportantContacts: {
    summary: "Keep in touch with your benefits information",
    contacts: {
      contact: [
        {
          name: "",
          information:""
        }
         
      ]
    }
  },
  benefitDetails: {
    resource: [
      {
        label: "This is an appearance",
        url: "http://testfile.empireblue.com.s3-website-us-east-1.amazonaws.com/182327/New%20Microsoft%20Word%20Document.docx"
      },
      {
        label: "BAsic 1",
        url: "http://testfile.anthem.com.s3-website-us-east-1.amazonaws.com/test1234/103350/SBCTest1.pdf"
      }
    ]
  },
  moreEnrollmentMaterials: {
    resource: {
      label: "More to come",
      url: "http://www.rrd.com"
    }
  },
  published: "false"
};